import { compareEffectsCanonical } from '../stats/effectiveStats.js';
/**
 * Планирует source-bound Щиты для всего damage batch, не мутируя state.
 * Локальные остатки гарантируют числовой effect.seq-порядок и не позволяют
 * одному Щиту поглотить одни и те же единицы в двух инструкциях снимка.
 */
export function planShieldMitigation(state, instructions) {
    const remainingByEffect = new Map(state.effects
        .filter((effect) => effect.shield !== undefined)
        .map((effect) => [effect.id, effect.shield.remaining]));
    return instructions.map((instruction) => {
        if (instruction.target.kind !== 'unit' || instruction.amount <= 0) {
            return { instruction: { ...instruction }, consumptions: [], absorbed: 0 };
        }
        const targetInstanceId = instruction.target.instanceId;
        let amount = instruction.amount;
        const consumptions = [];
        const shields = state.effects
            .filter((effect) => effect.scope.kind === 'unit'
            && effect.scope.instanceId === targetInstanceId
            && effect.shield !== undefined
            && (remainingByEffect.get(effect.id) ?? 0) > 0)
            .sort(compareEffectsCanonical);
        for (const effect of shields) {
            if (amount <= 0)
                break;
            const before = remainingByEffect.get(effect.id) ?? 0;
            const absorbed = Math.min(before, amount);
            if (absorbed <= 0)
                continue;
            const remaining = before - absorbed;
            remainingByEffect.set(effect.id, remaining);
            amount -= absorbed;
            consumptions.push({
                effectId: effect.id,
                sourceInstanceId: effect.shield.sourceInstanceId,
                targetInstanceId,
                amount: absorbed,
                remaining,
                ...(effect.shield.onDepletedCool !== undefined
                    ? { onDepletedCool: effect.shield.onDepletedCool }
                    : {}),
            });
        }
        return {
            instruction: { ...instruction, amount },
            consumptions,
            absorbed: instruction.amount - amount,
        };
    });
}
//# sourceMappingURL=shields.js.map